export default {
      id: "input__date-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "img/icons.svg#input__date",
      toString: function () {
        return this.url;
      }
    }